export const dataAbout = [
    {
        id: 1,
        title: 'REM Energy',
        text: 'Tokens are directly linked to the proprietary energy production technology of REM, supported by real-time energy outputs. Token holders enjoy discounted rates on energy through REM Credits.'
    },
    {
        id: 12,
        title: '',
        text: ""
    },
    {
        id: 13,
        title: '',
        text: ""
    },
    {
        id: 14,
        title: '',
        text: ""
    },
    {
        id: 2,
        title: 'PPA Impact',
        text: ' Increased contracts lead to broader deployment of REM technology, enhancing user base and overall REM power production, which in turn adds value to each REM Token'
    },
    {
        id: 3,
        title: 'Carbon Credits',
        text: 'As a major green energy initiative, increased REM energy production correlates with higher accumulation of Carbon Credits, with an annual dividend of 20% in carbon credits distributed to REM token stakers'
    },
    {
        id: 14,
        title: '',
        text: ""
    },
    {
        id: 18,
        title: '',
        text: ""
    },
    {
        id: 4,
        title: 'Token Scarcity',
        text: 'The total supply is capped at 300 million tokens, with a strategic release schedule based on milestones and a buy-back strategy to manage market presence'
    },
    {
        id: 5,
        title: 'Transparency',
        text: `REM's AI-driven smart meters ensure data transparency, displaying cumulative data through online REM platforms in real time.`
    },
    {
        id: 6,
        title: 'Market Presence',
        // text: `REM's visibility is bolstered through various projects, including:\n  i. REM port services\n  ii. REM EV charging stations\n  iii. Smart city initiatives by REM\n  iv. And more`
        text: `REM's visibility is bolstered through various projects, including:  1)REM port services  2)REM EV charging stations  3)Smart city initiatives by REM  iv. And more`
    }
];

export const dataBlockConst = {
    heading: 'TOKEN VALUE DRIVERS',
    desc: 'Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia dese runt mollit anim id est laborum velit esse cillum dolore eu fugiat nulla pariatu epteur sint occaecat'
}